(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/views/partials/missing-video.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/views/partials/missing-video.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.emp_video_player=_cmps.emp_video_player||{};
_cmps.emp_video_player.templates=_cmps.emp_video_player.templates||{};
svs.components.emp_video_player.templates.missing_video = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"emp-partial emp-missing\">\n  <div class=\"js-emp-partial-overlay emp-partial-overlay\">\n    "
    + container.escapeExpression((lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"icon",{"name":"ui","hash":{"color":"fc-white","icon":"remove-sign","size":"800"},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":64}}}))
    + "\n  </div>\n</div>\n";
},"useData":true});
Handlebars.partials['components-components-emp_video_player-missing_video'] = svs.components.emp_video_player.templates.missing_video;
})(svs, Handlebars);

 })(window);